// import config from './config';

// const getAuthHeader = () => {
//   const token = localStorage.getItem('token');
//   return token ? { Authorization: `Bearer ${token}` } : {};
// };

// const api = {
//   // ===== AUTH =====
//   login: (data) =>
//     fetch(`${config.apiBaseUrl}/auth/login`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(data),
//     }).then((res) => res.json()),

//   sendOtp: (data) =>
//     fetch(`${config.apiBaseUrl}/auth/send-otp`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(data),
//     }).then((res) => res.json()),

//   verifyOtp: (data) =>
//     fetch(`${config.apiBaseUrl}/auth/verify-otp`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(data),
//     }).then((res) => res.json()),

//   changePassword: (data) =>
//     fetch(`${config.apiBaseUrl}/auth/change-password`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(data),
//     }).then((res) => res.json()),

//   // ===== EMPLOYEE =====
//   getAllEmployees: (search = '') =>
//     fetch(`${config.apiBaseUrl}/employees?search=${search}`, {
//       headers: { ...getAuthHeader() },
//     }).then((res) => res.json()),

//   createEmployee: (data) =>
//     fetch(`${config.apiBaseUrl}/employees`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
//       body: JSON.stringify(data),
//     }).then((res) => res.json()),

//   updateEmployee: (id, data) =>
//     fetch(`${config.apiBaseUrl}/employees/${id}`, {
//       method: 'PUT',
//       headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
//       body: JSON.stringify(data),
//     }).then((res) => res.json()),

//   deleteEmployee: (id) =>
//     fetch(`${config.apiBaseUrl}/employees/${id}`, {
//       method: 'DELETE',
//       headers: { ...getAuthHeader() },
//     }).then((res) => res.json()),

//   // ===== ROLES =====
//   checkIsManager: () =>
//     fetch(`${config.apiBaseUrl}/employees/me/roles`, {
//       headers: { ...getAuthHeader() },
//     }).then((res) => res.json()),

//   // ===== APPRAISAL =====
//   getMyAppraisalForm: () =>
//     fetch(`${config.apiBaseUrl}/appraisal/my-form`, {
//       headers: { ...getAuthHeader() },
//     }).then((res) => res.json()),

//   getEmployeeAppraisalForm: (employeeId) =>
//     fetch(`${config.apiBaseUrl}/appraisal/employee/${employeeId}`, {
//       headers: { ...getAuthHeader() },
//     }).then((res) => res.json()),

//   saveAppraisalDraft: (data) =>
//     fetch(`${config.apiBaseUrl}/appraisal/save-draft`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
//       body: JSON.stringify(data),
//     }).then((res) => res.json()),

//   submitAppraisal: (data, employeeId = null) => {
//     const url = employeeId
//       ? `${config.apiBaseUrl}/appraisal/submit?employeeId=${employeeId}`
//       : `${config.apiBaseUrl}/appraisal/submit`;
//     return fetch(url, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
//       body: JSON.stringify(data),
//     }).then((res) => res.json());
//   },

//   getTeamAppraisalForms: () =>
//     fetch(`${config.apiBaseUrl}/appraisal/team`, {
//       headers: { ...getAuthHeader() },
//     }).then((res) => res.json()),

//   getAllAppraisalForms: () =>
//     fetch(`${config.apiBaseUrl}/appraisal/all`, {
//       headers: { ...getAuthHeader() },
//     }).then((res) => res.json()),
// };

// export default api;


import config from './config';

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// ===== SESSION EXPIRY HANDLING =====
// Anyone can subscribe to be notified when a 401 happens (AuthContext does this)
let onUnauthorized = () => {
  // Fallback if no listener registered yet — hard redirect
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  window.location.href = '/login?expired=true';
};

export const setUnauthorizedHandler = (handler) => {
  onUnauthorized = handler;
};

// Central fetch wrapper — every API call goes through this
const request = async (url, options = {}) => {
  let res;
  try {
    res = await fetch(url, options);
  } catch (networkErr) {
    // Network failure (server down, no internet, etc.)
    return { success: false, message: 'Network error. Please check your connection and try again.' };
  }

  let data;
  try {
    data = await res.json();
  } catch (parseErr) {
    data = undefined;
  }

  if (res.status === 401) {
    // Only an existing session can "expire" — that means a request that actually
    // carried a token. Login/OTP calls send no Authorization header, so a 401 there
    // is just a normal auth failure (e.g. wrong password) and should show as such.
    const hadToken = !!(options.headers && options.headers.Authorization);
    if (hadToken) {
      onUnauthorized();
      return { success: false, message: 'Session expired. Please log in again.', sessionExpired: true };
    }
    return { success: false, message: data?.message || 'Invalid email or password.' };
  }

  if (data === undefined) {
    return { success: false, message: 'Unexpected server response. Please try again.' };
  }

  // If backend didn't include a "success" flag but HTTP failed, mark it as failure
  if (!res.ok && data.success === undefined) {
    return { success: false, message: data.message || `Request failed (${res.status})` };
  }

  return data;
};

const api = {
  // ===== AUTH =====
  login: (data) =>
    request(`${config.apiBaseUrl}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }),

  sendOtp: (data) =>
    request(`${config.apiBaseUrl}/auth/send-otp`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }),

  verifyOtp: (data) =>
    request(`${config.apiBaseUrl}/auth/verify-otp`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }),

  changePassword: (data) =>
    request(`${config.apiBaseUrl}/auth/change-password`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }),

  // ===== EMPLOYEE =====
  getAllEmployees: (search = '') =>
    request(`${config.apiBaseUrl}/employees?search=${search}`, {
      headers: { ...getAuthHeader() },
    }),

  createEmployee: (data) =>
    request(`${config.apiBaseUrl}/employees`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
      body: JSON.stringify(data),
    }),

  updateEmployee: (id, data) =>
    request(`${config.apiBaseUrl}/employees/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
      body: JSON.stringify(data),
    }),

  deleteEmployee: (id) =>
    request(`${config.apiBaseUrl}/employees/${id}`, {
      method: 'DELETE',
      headers: { ...getAuthHeader() },
    }),

  // ===== ROLES =====
  checkIsManager: () =>
    request(`${config.apiBaseUrl}/employees/me/roles`, {
      headers: { ...getAuthHeader() },
    }),

  // ===== APPRAISAL =====
  getMyAppraisalForm: (reviewPeriodId) =>
    request(`${config.apiBaseUrl}/appraisal/my-form${reviewPeriodId ? `?reviewPeriodId=${reviewPeriodId}` : ''}`, {
      headers: { ...getAuthHeader() },
    }),

  getMyAppraisalPeriods: () =>
    request(`${config.apiBaseUrl}/appraisal/my-periods`, {
      headers: { ...getAuthHeader() },
    }),

  getEmployeeAppraisalForm: (employeeId, reviewPeriodId) =>
    request(`${config.apiBaseUrl}/appraisal/employee/${employeeId}${reviewPeriodId ? `?reviewPeriodId=${reviewPeriodId}` : ''}`, {
      headers: { ...getAuthHeader() },
    }),

  saveAppraisalDraft: (data, reviewPeriodId) =>
    request(`${config.apiBaseUrl}/appraisal/save-draft${reviewPeriodId ? `?reviewPeriodId=${reviewPeriodId}` : ''}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
      body: JSON.stringify(data),
    }),

  submitAppraisal: (data, employeeId = null, reviewPeriodId = null) => {
    const params = new URLSearchParams();
    if (employeeId) params.set('employeeId', employeeId);
    if (reviewPeriodId) params.set('reviewPeriodId', reviewPeriodId);
    const qs = params.toString();
    return request(`${config.apiBaseUrl}/appraisal/submit${qs ? `?${qs}` : ''}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
      body: JSON.stringify(data),
    });
  },

  getTeamAppraisalForms: (reviewPeriodId) =>
    request(`${config.apiBaseUrl}/appraisal/team${reviewPeriodId ? `?reviewPeriodId=${reviewPeriodId}` : ''}`, {
      headers: { ...getAuthHeader() },
    }),

  getAllAppraisalForms: (reviewPeriodId) =>
    request(`${config.apiBaseUrl}/appraisal/all${reviewPeriodId ? `?reviewPeriodId=${reviewPeriodId}` : ''}`, {
      headers: { ...getAuthHeader() },
    }),

  getDepartmentAppraisalForms: (reviewPeriodId) =>
    request(`${config.apiBaseUrl}/appraisal/department${reviewPeriodId ? `?reviewPeriodId=${reviewPeriodId}` : ''}`, {
      headers: { ...getAuthHeader() },
    }),

  // ===== REVIEW PERIODS =====
  getReviewPeriods: () =>
    request(`${config.apiBaseUrl}/review-periods`, {
      headers: { ...getAuthHeader() },
    }),

  createReviewPeriod: (data) =>
    request(`${config.apiBaseUrl}/review-periods`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
      body: JSON.stringify(data),
    }),

  updateReviewPeriodDeadline: (periodId, deadlineDate) =>
    request(`${config.apiBaseUrl}/review-periods/${periodId}/deadline`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
      body: JSON.stringify({ deadlineDate }),
    }),

  setReviewPeriodFrozen: (periodId, frozen) =>
    request(`${config.apiBaseUrl}/review-periods/${periodId}/freeze`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
      body: JSON.stringify({ frozen }),
    }),

  // ===== CODE OF CONDUCT ACKNOWLEDGEMENT =====
  getCodeOfConductStatus: () =>
    request(`${config.apiBaseUrl}/code-of-conduct/my-status`, {
      headers: { ...getAuthHeader() },
    }),

  submitCodeOfConduct: (data) =>
    request(`${config.apiBaseUrl}/code-of-conduct/submit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
      body: JSON.stringify(data),
    }),

  getCodeOfConductReport: () =>
    request(`${config.apiBaseUrl}/code-of-conduct/report`, {
      headers: { ...getAuthHeader() },
    }),

  // ===== REWARDS & RECOGNITION (R&R) =====
  getRnrWindows: () =>
    request(`${config.apiBaseUrl}/rnr/windows`, {
      headers: { ...getAuthHeader() },
    }),

  createRnrWindow: (data) =>
    request(`${config.apiBaseUrl}/rnr/windows`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
      body: JSON.stringify(data),
    }),

  setRnrWindowOpen: (windowId, open) =>
    request(`${config.apiBaseUrl}/rnr/windows/${windowId}/open`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
      body: JSON.stringify({ open }),
    }),

  submitRnrNomination: (data) =>
    request(`${config.apiBaseUrl}/rnr/nominations`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
      body: JSON.stringify(data),
    }),

  getMyRnrNominations: (windowId) =>
    request(`${config.apiBaseUrl}/rnr/nominations/mine${windowId ? `?windowId=${windowId}` : ''}`, {
      headers: { ...getAuthHeader() },
    }),

  getRnrWinners: (windowId) =>
    request(`${config.apiBaseUrl}/rnr/nominations/winners${windowId ? `?windowId=${windowId}` : ''}`, {
      headers: { ...getAuthHeader() },
    }),

  getAllRnrNominations: (windowId) =>
    request(`${config.apiBaseUrl}/rnr/nominations${windowId ? `?windowId=${windowId}` : ''}`, {
      headers: { ...getAuthHeader() },
    }),

  setRnrNominationStatus: (nominationId, status) =>
    request(`${config.apiBaseUrl}/rnr/nominations/${nominationId}/status`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
      body: JSON.stringify({ status }),
    }),
};

export default api;